import yup from "../utility/ValidationUtilty";

export type VideoContents = {
  id: string;
  type: "URL" | "YouTube";
  url: string;
  title: string;
  explanation: string;
  categoryIdOrderMaps: Record<string, string>;
  createUser: string;
  createUserType?: "admin" | "municipality";
  createAt: Date;
  companies?: string[];
};

export const newVideoContents = (): VideoContents => {
  return {
    id: "",
    type: "YouTube",
    url: "",
    title: "",
    explanation: "",
    categoryIdOrderMaps: {},
    createUser: "",
    createUserType: 'admin',
    createAt: new Date(),
    companies: []
  }
};

export const videoContentsSchema = yup.object({
  url: yup.string().required(),
  title: yup.string().required(),
});

// firestoreから取得したデータのマッピング
export const VideoContentsTimestampToDate = (data: any | undefined): VideoContents => {
  data.createAt = new Date(data?.createAt.seconds * 1000);
  return data;
};